import React from 'react';
import './Gallery.css';
import img1 from '../assets/3333-Mussarela-Sao-Leopoldo-1.jpg';
import img2 from '../assets/BACON MISTER BEEF FATIADO.png';
import img3 from '../assets/CRIOLO.webp';
import img4 from '../assets/WhatsApp Image 2024-11-15 at 08.49.33.jpeg';
import img5 from '../assets/WhatsApp Image 2024-11-15 at 08.49.34.jpeg';
import img6 from '../assets/WhatsApp Image 2024-11-15 at 09.23.40 (1).jpeg';
import img7 from '../assets/WhatsApp Image 2024-12-10 at 16.17.55.jpeg';

const Gallery = () => (
  <section className="gallery">
    <h2>Nossos Produtos</h2>
    <div className="gallery-grid">
      <img src={img1} alt="Queijo Mussarela São Leopoldo" />
      <img src={img2} alt="Bacon Mister Beef Fatiado" />
      <img src={img3} alt="Linguiça Criolo" />
      <img src={img4} alt="Produtos variados 1" />
      <img src={img5} alt="Produtos variados 2" />
      <img src={img6} alt="Produtos variados 3" />
      <img src={img7} alt="Produtos variados 4" />
    </div>
  </section>
);

export default Gallery;
